import React, {forwardRef} from 'react'
import {Box, Flex, Input, Text} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {CalendarIcon} from '../../icons'

export const CustomInput = forwardRef(
    (
        {
            value,
            onClick,
            placeholder,
            styles,
            isCalendarOpen,
            ariaInvalid,
            ariaDescribedBy,
            isFieldRequired,
        },
        ref,
    ) => {
        const {formatMessage} = useIntl()
        const hasValue = Boolean(value)

        return (
            <Flex {...styles?.customInputContainer} position="relative">
                <Box
                    {...styles?.customInput}
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    onClick={onClick}
                    data-invalid={ariaInvalid || undefined}
                >
                    {hasValue && placeholder && (
                        <Text data-testid="placeholder-label" {...styles?.placeholderLabel}>
                            {placeholder}
                        </Text>
                    )}
                    <Input
                        ref={ref}
                        value={value}
                        readOnly
                        placeholder={placeholder}
                        tabIndex={0}
                        aria-haspopup="dialog"
                        aria-expanded={isCalendarOpen}
                        aria-controls="calendar-popup"
                        aria-invalid={ariaInvalid}
                        aria-describedby={ariaDescribedBy}
                        data-testid="input"
                        aria-label={
                            placeholder ||
                            formatMessage({
                                id: 'date_picker.choose_date',
                                defaultMessage: 'Choose date',
                            })
                        }
                        onKeyDown={(e) => {
                            if (e.key !== 'Tab' && e.key !== 'Escape') {
                                e.preventDefault()
                                onClick()
                            }
                        }}
                        required={isFieldRequired}
                        variant="unstyled"
                        cursor="pointer"
                        {...styles?.inputText}
                    />
                </Box>

                <CalendarIcon data-testid="calendar-icon" {...styles?.calendarIcon} />
            </Flex>
        )
    },
)

CustomInput.displayName = 'CustomInput'

CustomInput.propTypes = {
    value: PropTypes.string,
    onClick: PropTypes.func,
    placeholder: PropTypes.string,
    styles: PropTypes.object,
    isCalendarOpen: PropTypes.bool,
    ariaInvalid: PropTypes.bool,
    ariaDescribedBy: PropTypes.string,
    isFieldRequired: PropTypes.bool,
}

export default CustomInput
